<template>
<div class="chapter">
<div class="inner_page">
<div class="imagea"><a id="page_xi"><img alt="Image" src="images/pgxi_1.jpg"/></a></div><a id="page_xi">
<p class="halftitle"><b>LINCOLN ROAD TRIP</b></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm1.vue?3bbb880e